import DropdownControl, {
    DropdownControlProps,
} from '@/features/ui/inputs/components/DropdownControl'
import ChevronDownIcon from '@/features/ui/inputs/components/DropdownControl/icons/ChevronDownIcon'
import ChevronUpIcon from '@/features/ui/inputs/components/DropdownControl/icons/ChevronUpIcon'
import { FC } from 'react'

type DropdownControlWithChevronProps = Omit<DropdownControlProps, 'TailIcon' | 'ActiveTailIcon'>

const DropdownControlWithChevron: FC<DropdownControlWithChevronProps> = ({
    children,
    ...props
}) => {
    return (
        <DropdownControl
            {...props}
            TailIcon={<ChevronDownIcon />}
            ActiveTailIcon={<ChevronUpIcon />}
        >
            {children}
        </DropdownControl>
    )
}

export default DropdownControlWithChevron
